const PosterPage = () => import("../../views/gameLottery/poster/posterPage.vue");
const InvitedPage = () => import("../../views/gameLottery/Invited/InvitedPage.vue");
const LotteryPage = () => import("../../views/gameLottery/Lottery/LotteryPage.vue");
const MyPrisePage = () => import("../../views/gameLottery/myPrize/myPrisePage.vue");
const ActivityFinishPage = () => import("../../views/gameLottery/activityFinished/activityFinishPage.vue");

const Container = {
    template: `
    <div style="height: 100%">
      <router-view></router-view>
    </div>
  `,
};

const router = {
    path: '/lottery',
    name: 'lotteryContainer',
    component: Container,
    children: [
        {
            path: '/poster',
            name: 'PosterPage',
            component: PosterPage
        },
        {
            // 访问/invited?inviteCode=12345
            path: '/invited',
            name: 'InvitedPage',
            component: InvitedPage,
        },
        {
            path:'/lottery',
            name:"LotteryPage",
            component:LotteryPage
        },
        {
            path: '/myPrise',
            name: 'MyPrise',
            component: MyPrisePage
        },
        {
            path: '/activityFinish',
            name: 'ActivityFinishPage',
            component: ActivityFinishPage
        },
    ]
}




export default router;


// WEBPACK FOOTER //
// ./src/router/modules/gameLottery.js